import { FC, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Stack } from '@mui/material';
import {
  Product,
  chatActions,
  chatSelectors,
  useAppDispatch,
  useAppSelector,
} from '@vs-online-only-app/state';
import { ProductCard, ThumbnailSize } from '@vs-online-only-app/ui';

const Container = styled(Stack)`
  flex-direction: row;
  overflow-x: auto;
  gap: ${({ theme }) => theme.spacing(1)};
`;

type Props = {
  products: Product[];
};

const MessageComposerSharedProductsCarousel: FC<Props> = ({ products }) => {
  const dispatch = useAppDispatch();
  const selectedConversation = useAppSelector(
    chatSelectors.selectSelectedConversation,
  );

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.scrollTo({ left: ref.current?.scrollWidth });
  }, [products]);

  const onRemove = (product: Product) => {
    if (!selectedConversation) return;

    dispatch(
      chatActions.removeConversationSharedProduct({
        conversationId: selectedConversation.id,
        product,
      }),
    );
  };

  return (
    <Container ref={ref}>
      {products.map((product) => (
        <ProductCard
          key={product.url}
          product={product}
          thumbnailSize={ThumbnailSize.Small}
          onRemove={() => onRemove(product)}
        />
      ))}
    </Container>
  );
};

export default MessageComposerSharedProductsCarousel;
